var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6905 90.4762H10.0238V23.8095H52.881V14.2857H10.0238C4.78571 14.2857 0.5 18.5714 0.5 23.8095V90.4762C0.5 95.7143 4.78571 100 10.0238 100H76.6905C81.9286 100 86.2143 95.7143 86.2143 90.4762V47.6191H76.6905V90.4762ZM39.5952 75.381L30.2619 64.1429L17.1667 80.9524H69.5476L52.6905 58.5238L39.5952 75.381ZM86.2143 14.2857V0H76.6905V14.2857H62.4048C62.4524 14.3333 62.4048 23.8095 62.4048 23.8095H76.6905V38.0476C76.7381 38.0952 86.2143 38.0476 86.2143 38.0476V23.8095H100.5V14.2857H86.2143Z",
    fill: "#1A96F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAdd);
export default __webpack_public_path__ + "static/media/image-add.6c1538429ea6cacf41528e938a583264.svg";
export { ForwardRef as ReactComponent };